var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2485 5.35986C54.2485 2.46037 51.898 0.109863 48.9985 0.109863C46.099 0.109863 43.7485 2.46037 43.7485 5.35986V13.9246C28.3654 16.2066 16.2037 28.3675 13.9205 43.7503H5.35938C2.45988 43.7503 0.109375 46.1008 0.109375 49.0003C0.109375 51.8998 2.45988 54.2503 5.35938 54.2503H13.9202C16.2026 69.634 28.3647 81.7958 43.7485 84.078V92.6401C43.7485 95.5396 46.099 97.8901 48.9985 97.8901C51.898 97.8901 54.2485 95.5396 54.2485 92.6401V84.0775C69.6307 81.794 81.7911 69.6329 84.0734 54.2503H92.6418C95.5413 54.2503 97.8918 51.8998 97.8918 49.0003C97.8918 46.1008 95.5413 43.7503 92.6418 43.7503H84.0731C81.79 28.3687 69.63 16.2084 54.2485 13.9251V5.35986ZM24.0371 49.0003C24.0371 49.0521 24.0363 49.1036 24.0349 49.1551C24.1174 62.8361 35.2057 73.9077 48.893 73.9634C48.9281 73.9627 48.9632 73.9624 48.9985 73.9624L49.0341 73.9625L49.0658 73.9628L49.1034 73.9634C62.8407 73.906 73.9592 62.7521 73.9592 49.0013C73.9592 35.2149 62.7831 24.0389 48.9968 24.0389C35.2623 24.0389 24.1185 35.131 24.0349 48.8458C24.0364 48.8971 24.0371 48.9486 24.0371 49.0003ZM40.3939 48.9994C40.3939 44.2447 44.2483 40.3903 49.003 40.3903C53.7577 40.3903 57.6122 44.2447 57.6122 48.9994C57.6122 53.7541 53.7577 57.6086 49.003 57.6086C44.2483 57.6086 40.3939 53.7541 40.3939 48.9994Z",
    fill: "#096F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.26a907ef97dc909f6b8e5e25eff26f45.svg";
export { ForwardRef as ReactComponent };